import { render, staticRenderFns } from "./AboutUsSection.vue?vue&type=template&id=01387e1a&scoped=true&"
import script from "./AboutUsSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsSection.vue?vue&type=style&index=0&id=01387e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01387e1a",
  null
  
)

export default component.exports